import { PortalUrlProvider } from './PortalUrlProvider'
import { AuthotizationHandler } from './AuthorizationHandler'
import { JwtUser } from './Models/JwtUser'
/*import { type } from 'os';*/
/**
 * @private-doc
 */
export class ApprovalHandler {
  public static htmlModalElement?: HTMLElement
  private modalId = 'ec-approval-modal'

  private modalContent: string = `
     <div style="position: absolute; overflow: hidden;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background-color: white;
                    /*padding: 1rem 1.5rem;*/
                    /*width: 24rem;*/
                    height:420px;
                    border-radius: 10px;"
     >
         <div id="ec-approval-modal-container" style="overflow: hidden;">
         <iframe id="ec-modal-approval-iframe" width=300 height=420 style="border:none;margin:5px;overflow: hidden;" src=""></iframe>
         </div>
     </div>`
  private authHandler: AuthotizationHandler
  static approvalResolver: any = null
  // tslint:disable-next-line:no-empty
  constructor() {
    /*if (!this.modalExist()) {
      this.htmlModalElement = document.createElement('div')
      this.htmlModalElement.id = this.modalId
      this.htmlModalElement.style.position = 'fixed'
      this.htmlModalElement.style.left = '0'
      this.htmlModalElement.style.top = '0'
      this.htmlModalElement.style.width = '100%'
      this.htmlModalElement.style.height = '100%'
      this.htmlModalElement.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
      this.htmlModalElement.style.opacity = '0'
      this.htmlModalElement.style.visibility = 'hidden'
      this.htmlModalElement.style.transform = 'scale(1.1)'
      this.htmlModalElement.style.transition =
        'visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s'
      this.htmlModalElement.innerHTML = this.modalContent
      document.body.appendChild(this.htmlModalElement)
    } else {
      this.htmlModalElement = document.getElementById(this.modalId) as HTMLElement
    }*/

    this.authHandler = new AuthotizationHandler()
  }

  public loadModal(): void {
    if (!this.modalExist()) {
      ApprovalHandler.htmlModalElement = document.createElement('div')
      ApprovalHandler.htmlModalElement.id = this.modalId
      ApprovalHandler.htmlModalElement.style.position = 'fixed'
      ApprovalHandler.htmlModalElement.style.left = '0'
      ApprovalHandler.htmlModalElement.style.top = '0'
      ApprovalHandler.htmlModalElement.style.width = '100%'
      ApprovalHandler.htmlModalElement.style.height = '100%'
      ApprovalHandler.htmlModalElement.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
      ApprovalHandler.htmlModalElement.style.opacity = '0'
      ApprovalHandler.htmlModalElement.style.visibility = 'hidden'
      /* ApprovalHandler.htmlModalElement.style.transform = 'scale(1)'
      ApprovalHandler.htmlModalElement.style.transition =
        'visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s'*/
      ApprovalHandler.htmlModalElement.innerHTML = this.modalContent
      document.body.appendChild(ApprovalHandler.htmlModalElement)
    } else {
      ApprovalHandler.htmlModalElement = document.getElementById(this.modalId) as HTMLElement
    }
  }
  public toggleModal(): void {
    this.loadModal()
    this.toggleStyles()
  }

  private hideModal(): void {
    ApprovalHandler.htmlModalElement!.style.transition =
      'visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s'
    ApprovalHandler.htmlModalElement!.style.visibility = 'hidden'
    ApprovalHandler.htmlModalElement!.style.opacity = '0'
    ApprovalHandler.htmlModalElement!.style.transform = 'scale(1.1)'
    const me = this
    setTimeout(function() {
      if (me.modalExist()) {
        const el = document.getElementById(me.modalId) as HTMLElement
        el.parentNode!.removeChild(el)
      }
    }, 1)
  }

  private showModal(): void {
    this.loadModal()
    //  ApprovalHandler.htmlModalElement!.style.opacity = '1'
    //  ApprovalHandler.htmlModalElement!.style.transform = 'scale(1.0)'
    //  ApprovalHandler.htmlModalElement!.style.visibility = 'visible'
  }

  private toggleStyles(): void {
    ApprovalHandler.htmlModalElement = document.getElementById(this.modalId) as HTMLElement
    const iframe = document.getElementById('ec-modal-approval-iframe') as HTMLIFrameElement
    const me = this
    let onload = function() {
      // setTimeout(function() {
      ApprovalHandler.htmlModalElement!.style.opacity = '1'
      ApprovalHandler.htmlModalElement!.style.transform = 'scale(1.0)'
      ApprovalHandler.htmlModalElement!.style.visibility = 'visible'
      ApprovalHandler.htmlModalElement!.style.transition =
        'visibility 0s linear 1s, opacity 0.25s 1s, transform 1.25s'
      //}, 500);
      iframe.removeEventListener('load', onload)
    }
    if (ApprovalHandler.htmlModalElement.style.visibility === 'hidden') {
      iframe.addEventListener('load', onload)
      iframe.src = PortalUrlProvider.PortalUrl + '/approve/embedded'
      this.showModal()
    } else {
      this.hideModal()
    }
    // if(!iframe.src || iframe.src.indexOf(PortalUrlProvider.PortalUrl)===-1){
    // }
  }
  private modalExist(): boolean {
    return document.getElementById(this.modalId) !== null
  }
  public EnsureBaseUrl(): Promise<boolean> {
    const me = this
    return new Promise<boolean>(function(resolve, reject) {
      if (!PortalUrlProvider.PortalUrl) {
        me.authHandler.GetUserInfo(function(user?: JwtUser) {
          if (user) {
            PortalUrlProvider.PortalUrl = me.authHandler.getPortalUrl(user, true)

            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else {
        resolve(true)
      }
    })
  }
}
